<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_rewards', 2),
                        href: meta.links.index,
                    },
                    {
                        name: reward.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navGroupLinks" />
        </div>

        <div class="mt-5">
            <EmptyState v-if="networkGraph.teachers.length === 0" picture />
            <div v-else>
                <NetworkGraphRewardTeachersStudents
                    :teachers="networkGraph.teachers"
                    :students="networkGraph.students"
                    :table="networkGraph.table"
                    :is-negative="reward.is_negative"
                />
            </div>
        </div>

        <form :action="meta.links.show" method="post" @submit.prevent="filter">
            <div class="md:grid sm:grid-cols-12 md:gap-6">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_from')" for="date_from" />
                        <FormInput id="date_from" v-model="form.date_from" type="date" name="date_from" class="mt-1" />
                        <FormError :value="form.errors.date_from" class="mt-2" />
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_to')" for="date_to" />
                        <FormInput id="date_to" v-model="form.date_to" type="date" name="date_to" class="mt-1" />
                        <FormError :value="form.errors.date_to" class="mt-2" />
                    </div>
                </div>
                <div class="sm:col-span-2 align-bottom">
                    <label class="block text-sm font-medium leading-5 text-gray-700 mt-1"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import NetworkGraphRewardTeachersStudents from '@/components/pageSpecific/NetworkGraphRewardTeachersStudents.vue';
import NavLinks from '@/components/NavLinks.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    components: {
        FormError,
        SubmitFormButton,
        FormLabel,
        FormInput,
        NavLinks,
        EmptyState,
        NetworkGraphRewardTeachersStudents,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'filters', 'reward', 'gamificationSet', 'networkGraph'],
    data() {
        return {
            form: this.$inertia.form({
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
            }),
        };
    },
    computed: {},
    methods: {
        filter() {
            this.form.get(this.meta.links.show, {
                preserveScroll: true,
            });
        },
    },
};
</script>
